export const VERIFY_EMAIL = "VERIFY_EMAIL"
export const VERIFY_EMAIL_SUCCESSFUL = "VERIFY_EMAIL_SUCCESSFUL"
export const VERIFY_EMAIL_FAILED = "VERIFY_EMAIL_FAILED"


export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_SUCCESSFUL = "RESET_PASSWORD_SUCCESSFUL"
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED"
